<template>
	<div class="layout" v-loading="loading">
		<div class="layout-navber">
			<div>
				<span>{{$t('title')}}</span>
			</div>
			<div>
				<el-dropdown @command="changeLanguage">
					<span style="cursor: pointer;">
						{{$t($i18n.locale)}}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="zh">{{$t('zh')}}</el-dropdown-item>
						<el-dropdown-item command="en">{{$t('en')}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-dropdown @command="userClick">
					<span style="cursor: pointer;">
						<span>{{ userName }}</span>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="updatePasswordHandle">{{$t('updatePassword')}}</el-dropdown-item>
						<el-dropdown-item command="logoutHandle">{{$t('logout')}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

			</div>
		</div>
		<div class="layout-content">
			<div :class="{'layout-menuList':1,'layout-menuList-sidebarFold':sidebarFold}">
				<el-menu :default-active="menuActiveName || 'home'" :collapse="sidebarFold" :collapseTransition="false"
					background-color="#007aff" text-color="#dedede" active-text-color="#fff">
					<!-- <el-menu-item index="home" @click="$router.push({ name: 'home' })">
						<span slot="title">{{$t('homePage')}}</span>
					</el-menu-item> -->
					<sub-menu v-for="menu in menuList.filter(v=>v.type>userType)" :key="menu.menuId" :menu="menu"
						:dynamicMenuRoutes="dynamicMenuRoutes" />
				</el-menu>
			</div>
			<div v-if="!loading">
				<div class="view_content">
					<keep-alive>
						<router-view></router-view>
					</keep-alive>
				</div>
			</div>
		</div>
		<update-password v-if="updatePassowrdVisible" ref="updatePassowrd" />
	</div>
</template>

<script>
	import UpdatePassword from './update-password';
	import SubMenu from './sub-menu'
	import {
		clearLoginInfo
	} from '@/utils';
	export default {
		components: {
			UpdatePassword,
			SubMenu,
		},
		data() {
			return {
				loading: true,
				updatePassowrdVisible: false,
				dynamicMenuRoutes: [],
				userType: '4',
			}
		},
		computed: {
			menuList: {
				get() {
					return this.$store.state.common.menuList;
				},
				// set(val) {
				// 	this.$store.commit('common/updateMenuList', val);
				// }
			},
			menuActiveName: {
				get() {
					return this.$store.state.common.menuActiveName;
				},
				set(val) {
					this.$store.commit('common/updateMenuActiveName', val);
				}
			},
			navbarLayoutType: {
				get() {
					return this.$store.state.common.navbarLayoutType;
				}
			},
			sidebarFold: {
				get() {
					return this.$store.state.common.sidebarFold;
				},
				set(val) {
					this.$store.commit('common/updateSidebarFold', val);
				}
			},
			mainTabs: {
				get() {
					return this.$store.state.common.mainTabs;
				},
				set(val) {
					this.$store.commit('common/updateMainTabs', val);
				}
			},
			userName: {
				get() {
					return this.$store.state.user.name;
				},
				set(val) {
					this.$store.commit('user/updateName', val);
				}
			},
		},
		watch: {
			$route: function(newRoute) {
				this.setMenuActiveName(newRoute)
			},
		},
		created() {
			this.loading = true;
			this.setMenuActiveName(this.$route)
			this.dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]');
			this.getUserInfo();
		},
		mounted() {

		},
		methods: {
			userClick(fun) {
				this[fun]()
			},
			changeLanguage(lang) {
				this.$i18n.locale = lang;
				localStorage.setItem('language', lang);
				// location.reload();
			},
			setMenuActiveName(route) {
				if (route && route.meta.menuId) {
					this.$store.commit('common/updateMenuActiveName', route.meta.menuId);
					sessionStorage.setItem('menuActiveName', route.meta.menuId);
				}
			},
			// 修改密码
			updatePasswordHandle() {
				this.updatePassowrdVisible = true;
				this.$nextTick(() => {
					this.$refs.updatePassowrd.init();
				});
			},
			getUserInfo() {
				let navs = [];
				let arrayList = [];
				this.$http({
					url: this.$http.adornUrl('/sys/user/info/' + sessionStorage.getItem('userId')),
					method: 'get',
					params: this.$http.adornParams()
				}).then(({
					data
				}) => {
					if (data && data.code === 0) {
						this.loading = false;
						this.userName = data.user.name
						this.userType = data.user.type
						sessionStorage.setItem('user', JSON.stringify(data.user));
					} else {
						clearLoginInfo();
						this.$router.replace({
							name: 'login'
						});
					}
				});
			},
			// 退出
			logoutHandle() {
				this.$confirm(`确定进行[退出]操作?`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						clearLoginInfo();
						this.$router.replace({
							name: 'login'
						});
						// this.$http({
						// 	url: this.$http.adornUrl('/sys/logout'),
						// 	method: 'post',
						// 	data: this.$http.adornData()
						// }).then(({
						// 	data
						// }) => {
						// 	if (data && data.code === 0) {
						// 		clearLoginInfo();
						// 		this.$router.replace({
						// 			name: 'login'
						// 		});
						// 	}
						// });
					})
					.catch(() => {});
			},
		},
	}
</script>

<style lang="scss">
	.layout {
		width: 100vw;
		height: 100vh;
		background: #eaeef3;
		overflow: hidden;

		&-navber {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			background: #fff;

			&>div:nth-child(1) {
				display: flex;
				align-items: center;
			}

			i {
				margin-right: 30px;
				cursor: pointer;
			}

			>div:first-child {
				i {
					font-size: 20px;
				}

				img {
					width: 24px;
					height: 24px;
					object-fit: contain;
					margin-right: 10px;

				}

				img+span {
					font-weight: 700;
					font-size: 18px;
					letter-spacing: 1px;
					color: #007aff;
				}
			}

			>div:last-child {
				color: #007aff;
				font-size: 14px;
				font-weight: 400;

				img {
					width: 20px;
					height: 20px;
					margin-left: 24px;
					cursor: pointer;
				}
			}
		}

		&-content {
			width: 100%;
			height: calc(100% - 50px);
			display: flex;
		}

		&-menuList+div {
			width: calc(100% - 200px);
			transition: all .3s;

			.view_content {
				width: 100%;
				padding: 15px;
				height: 100%;

				&>div {
					height: 100%;
					padding: 16px;
					border-radius: 4px;
					overflow-y: auto;
					background-color: #fff;
					background: #FFFFFF;
					box-shadow: 0px 1px 5px #00000012;
				}
			}

		}

		.el-menu {
			border: none;
		}

		&-menuList {
			height: 100%;
			width: 200px;
			flex-shrink: 0;
			overflow-y: auto;
			background: #007aff;
			transition: all .3s;

			&-sidebarFold {
				width: 64px;
			}

			&-sidebarFold+div {
				width: calc(100% - 64px);
			}

			.el-menu-item.is-active {
				background-color: rgb(255, 255, 255, 0.2) !important;
			}
		}
	}
</style>